var _style, _g, _path, _polyline, _path2, _polyline2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCostAndEnvironmentV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 106.9 95.8",
    style: {
      enableBackground: "new 0 0 106.9 95.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#1D1D1B;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_cost-and-environment_v2.3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_cost-and-environment"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.1,25.5c0,0,0,16.2-6.4,25S84.7,62,80.1,58S76.6,46.4,83,37.7S104.1,25.5,104.1,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.8,63.4c0.7-1.8,1.4-3.6,2.3-5.3c2.4-4.1,5.1-8,8-11.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,56.8c0,1.8,5.1,3.3,11.5,3.3S28,58.6,28,56.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28,47.6c0,1.8-5.1,3.3-11.5,3.3S5,49.5,5,47.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,38.5c0,1.8,5.1,3.3,11.5,3.3S28,40.5,28,38.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28,52.2c0,1.8-5.1,3.3-11.5,3.3S5,54,5,52.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,43.1c0,1.8,5.1,3.3,11.5,3.3S28,44.9,28,43.1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 16.5,
    cy: 34,
    rx: 11.5,
    ry: 3.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 28,
    y1: 34,
    x2: 28,
    y2: 56.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 5,
    y1: 34,
    x2: 5,
    y2: 56.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.3,68.7c0,1.8,5.1,3.3,11.5,3.3s11.5-1.4,11.5-3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.3,68.7c0,1.8,5.1,3.3,11.5,3.3s11.5-1.4,11.5-3.3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 40.8,
    cy: 64.1,
    rx: 11.5,
    ry: 3.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 52.2,
    y1: 64.1,
    x2: 52.2,
    y2: 68.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 29.3,
    y1: 64.1,
    x2: 29.3,
    y2: 68.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "house"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "house-2",
    className: "st0",
    points: "69.8,53.5 59.8,53.5 49,53.5 39,53.5 39.1,30.4 35.8,33.3 43.1,26.9 54.5,16.9     73.1,33.3 69.8,30.4   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.7,18.2L42.7,18.2z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "47.7,22.8 47.7,18.2 42.7,18.2 42.7,26.9  "
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.3,24c13.2-19.9,40-25.4,60-12.2c5.1,3.4,9.5,7.8,12.7,13"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "81.4,23.5 90,24.8 92.1,16.5 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.4,64.6c-9.3,22.1-34.7,32.5-56.7,23.2C27.5,84,20,77.2,15.3,68.5"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "22.5,70.2 15.3,68.5 13,75.6 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCostAndEnvironmentV2);
export default __webpack_public_path__ + "static/media/icon_cost-and-environment_v2.abd63278220b5c2bd7ee53fa1f5bb19a.svg";
export { ForwardRef as ReactComponent };